/**
 * @memberOf app
 * @ngdoc module
 * @description Results module that is used for the page when a user actually clicks 'View' and views the results of a
 * particular study.
 * @name app.results
 */

import './results.css';
import routing from './results.route';
import ResultsController from './results.controller';
import ReportService from '../services/report.service';

export default angular.module('app.results', [ReportService])
  .config(routing)
  .controller('ResultsController', ResultsController)
  .name;




// WEBPACK FOOTER //
// ./src/client/app/results/results.module.js